const $inject = []

function AspectRatio() {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
            const width = elem.parent().width(),
                ratio = scope.$eval(attrs.aspectRatio),
                height = width * ratio;

            setTimeout(() => elem.height(height));   
        }
    };
}

AspectRatio.$inject = $inject

export default AspectRatio